import { BaseHealthCardParser } from "./BaseHealthCardParser";

export class QuebecCardParser extends BaseHealthCardParser {
    private OneDimensionRegex = /^[A-Z]{4}\d{8}/;
    private TwoDimensionRegex = [
        /^CNAM(?<HealthCareNumber>[A-Z]{4}\d{8})CPRN(?<FirstName>.*)CNOM(?<LastName>.*)(CEPO.*)CSEQ(?<SequenceNumber>.*)CEXP(?<CardExpiry>\d{4}-\d{2})CDTN(?<DateOfBirth>\d{4}-\d{2}-\d{2})CSEX(?<Sex>\w)*/
    ];

    protected GetOneDimensionRegex(): RegExp {
        return this.OneDimensionRegex;
    }

    protected GetTwoDimensionRegex(): RegExp[] {
        return this.TwoDimensionRegex;
    }
}



// WEBPACK FOOTER //
// ./src/services/HealthCardBarcodeScanParsers/QuebecHealthCardScanParser.ts